/** @jsx jsx */
// eslint-disable-next-line
import React, { useCallback } from 'react'
import { css, jsx } from '@emotion/core'
import formatDate from '../utils/formatDate'
import { palette } from '../constants'
import Day from './Day'
import propTypes from 'prop-types'

const styles = {
  container: css`
    display: flex;
    background: ${palette.white};
    width: 100%;
    flex-direction: column;
    height: 100%;
    border: 1px solid ${palette.white};
  `,
  row: css`
    display: flex;
    flex: 1;
  `,
  item: css`
    display: flex;
    flex: 1;
    height: 100%;
    border: 1px solid ${palette.white};
    background: ${palette.grey2};
    transition: none;
    border-radius: 6px;
    padding: 3px;
    font-size: 11px;
    font-weight: 400;
    pointer-events: none;
  `,
  weekRow: css`
    height: 40px;
    display: flex;
  `,
  weekDay: css`
    flex: 1;
    border: 1px solid ${palette.white};
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${palette.white};
    color: ${palette.grey3};
    font-weight: bold;
    font-size: 14px;
  `,
}

const isToday = (date, dayNumber) => {
  const today = new Date()
  const todayDate = formatDate(today)
  const yearMatch = date.split('-')[0] === todayDate.split('-')[0]
  const monthMatch = date.split('-')[1] === todayDate.split('-')[1]
  const dayMatch = Number(dayNumber) === Number(today.getDate())
  return yearMatch && monthMatch && dayMatch
}
const perRow = 7
const daysList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const makeArray = listLength => [...Array(listLength).keys()]

function Calendar({ date, reminders }) {
  const year = Number(date.split('-')[0])
  const month = Number(date.split('-')[1])
  const daysInMonth = new Date(year, month, 0).getDate()
  const skipStartDayCount = new Date(year, month - 1, 1).getDay()
  const cantRow = Math.ceil((skipStartDayCount + daysInMonth) / 7)

  const listReminders = useCallback(
    dayNumber =>
      Object.values(reminders[`${date}-${dayNumber}`] || {}).sort(
        (a, b) => Number(a.startTime.split(':')[0]) - Number(b.startTime.split(':')[0])
      ),
    [reminders, date]
  )

  return (
    <div css={styles.container}>
      <div css={styles.weekRow}>
        {/* Week days */}
        {daysList.map(day => (
          <div key={day} data-week-day={day} css={styles.weekDay}>
            {day}
          </div>
        ))}
      </div>
      {/* Rows */}
      {makeArray(cantRow).map((i, rowIdx) => (
        <div key={i} data-row-number={i + 1} css={styles.row}>
          {/* Items inside the row */}
          {makeArray(perRow).map(j => {
            const itemNumber = j + 1 + perRow * rowIdx
            const dayNumber = itemNumber - skipStartDayCount // We need to do this since not every sunday is 1th
            const isValidDay = dayNumber > 0 && dayNumber <= daysInMonth

            return isValidDay ? (
              <Day
                key={j}
                isToday={isToday(date, dayNumber)}
                dayNumber={dayNumber}
                itemNumber={itemNumber}
                baseStyles={styles.item}
                listReminders={listReminders(dayNumber)}
              />
            ) : (
              <div key={j} data-item-number={itemNumber} css={styles.item} />
            )
          })}
        </div>
      ))}
    </div>
  )
}

Calendar.propTypes = {
  date: propTypes.string.isRequired,
  reminders: propTypes.object.isRequired,
}

export default Calendar
